import React, { useMemo, useState } from "react";
import { Search } from "lucide-react";

import { Input } from "../../../components/ui/input";

import { slugCategoria } from "./formato";
import CategoriaOferta from "./produtos/CategoriaOferta";
import { agruparOrdenado, algumParticipa, marcarProdutos } from "./produtos/ordem";

// Produtos por categoria. Categorias e produtos na campanha vêm primeiro e
// abertos; o que está fora fica recolhido (só foto e nome). As pílulas abaixo
// da busca levam até a categoria, igual ao cardápio.
export default function SecaoProdutos({ produtos, categorias, config, configSalva, onMudarConfig }) {
  const [busca, setBusca] = useState("");
  const [pilula, setPilula] = useState(null);
  const grupos = useMemo(
    () => agruparOrdenado(produtos, categorias, busca, configSalva || config),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- a ordem segue a config salva, não cada clique
    [produtos, categorias, busca, configSalva],
  );
  const [abertas, setAbertas] = useState(() => new Set(
    agruparOrdenado(produtos, categorias, "", configSalva || config)
      .filter(([, lista]) => lista.some((p) => algumParticipa(p, configSalva || config)))
      .map(([c]) => c),
  ));
  const buscando = busca.trim() !== "";

  const abrir = (categoria, aberta) => setAbertas((atual) => {
    const novo = new Set(atual);
    if (aberta) novo.add(categoria); else novo.delete(categoria);
    return novo;
  });
  const mudarProduto = (id, regra) => onMudarConfig({ ...config, produtos: { ...config.produtos, [id]: regra } });
  const mudarPizza = (id, tam, regra) => onMudarConfig({
    ...config, pizza: { ...config.pizza, [id]: { ...(config.pizza?.[id] || {}), [tam]: regra } },
  });
  const marcarTudo = (categoria, lista, marcar) => {
    onMudarConfig(marcarProdutos(config, lista, marcar));
    abrir(categoria, marcar);
  };
  const irPara = (categoria) => {
    setPilula(categoria);
    abrir(categoria, true);
    setTimeout(() => document.getElementById(`cat-oferta-${slugCategoria(categoria)}`)?.scrollIntoView({ behavior: "smooth", block: "start" }), 0);
  };

  return (
    <div>
      <div className="sticky top-0 z-10 bg-background pb-2 pt-1 space-y-2">
        <div className="relative">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="Buscar produto" className="pl-9" />
        </div>
        <div className="flex gap-2 overflow-x-auto pb-1" style={{ scrollbarWidth: "none" }} data-e2e="pilulas-categorias">
          {grupos.map(([categoria, lista]) => {
            const n = lista.filter((p) => algumParticipa(p, config)).length;
            return (
              <button key={categoria} type="button" onClick={() => irPara(categoria)}
                className={`shrink-0 px-3.5 py-1.5 rounded-full text-xs font-semibold border transition-all active:scale-95 ${pilula === categoria ? "bg-primary text-primary-foreground border-primary" : "bg-card hover:bg-muted border-border"}`}>
                {n > 0 && <span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-500 mr-1.5 align-middle" />}
                {categoria} <span className="opacity-70 tabular-nums">{n}/{lista.length}</span>
              </button>
            );
          })}
        </div>
      </div>
      {grupos.length === 0 && <p className="text-sm text-muted-foreground text-center py-6">Nenhum produto encontrado.</p>}
      <div className="space-y-2.5 mt-2">
        {grupos.map(([categoria, lista]) => (
          <CategoriaOferta key={categoria} categoria={categoria} lista={lista} config={config}
            aberta={buscando || abertas.has(categoria)} onAlternar={() => abrir(categoria, !abertas.has(categoria))}
            onMarcarTudo={(marcar) => marcarTudo(categoria, lista, marcar)}
            onMudarProduto={mudarProduto} onMudarPizza={mudarPizza}
            onMarcar={(p, marcar) => onMudarConfig(marcarProdutos(config, [p], marcar))} />
        ))}
      </div>
    </div>
  );
}
